import React, { Component } from 'react'
import styled from 'styled-components'
import { SelectableSizeTile } from 'app/ecommerce/common/components/catalog'
import { FormattedMessage } from 'react-intl'
import { H4, Text } from 'app/common/typography'
import { updateOrderMenu } from 'shared/utils/ecommerce/utils'
import type { PurchasableItem } from 'shared/store/ecommerce/order'
import type { Menu } from 'shared/store/ecommerce/catalog'
import { menuSize } from 'shared/utils'
import menuSizeXL from 'shared/assets/images/menu-XL.png'
import menuSizeM from 'shared/assets/images/menu-M.png'
import menuSizeL from 'shared/assets/images/menu-L.png'
import menuSizeS from 'shared/assets/images/menu-S.png'
import { menuSizeName } from 'shared/utils'

const {
    S: MENU_SIZE_S,
    M: MENU_SIZE_M,
    L: MENU_SIZE_L,
    XL: MENU_SIZE_XL
} = menuSize

type Props = {
    order: ?PurchasableItem,
    menu: Menu,
    dispatchOrder: (order: ?PurchasableItem) => void,
    isFromCart: boolean,
    changeIsSizeSelected: (isSizeSelected: boolean) => void
}

type State = {
    largeSelected?: boolean,
    mediumSelected: boolean
}

class CatalogMenuSize extends Component<Props, State> {
    constructor(props: Props) {
        super(props)
        const { isFromCart, order } = props
        this.state = {
            menuSize: order ? isFromCart && order.menuSize : false
        }
    }

    onProductSelected = (newSize: string) => {
        const { dispatchOrder, order, menu, changeIsSizeSelected } = this.props
        changeIsSizeSelected(true)
        const updateOrder = updateOrderMenu(menu, newSize, order)
        dispatchOrder(updateOrder)
        this.setState({
            menuSize: newSize
        })
    }

    render() {
        const { menuSize } = this.state
        const { menu, isFromCart } = this.props
        const {
            id,
            price,
            priceS,
            priceL,
            priceXL,
            existsInL,
            existsInXL,
            existsInS
        } = menu

        const basePrice = priceS || price

        const calculateExtraPrice = (specialSizePrice: number) => {
            return specialSizePrice && basePrice && specialSizePrice - basePrice
        }
        return (
            <Container>
                <FormattedMessage id="clickandcollect.catalog.menu.size">
                    {(label: string) => <StyledH4>{label}</StyledH4>}
                </FormattedMessage>
                <TilesContainer>
                    {existsInXL && (
                        <SelectableSizeTile
                            id={id}
                            price={priceXL}
                            selectableSizeName={menuSizeName[MENU_SIZE_XL]}
                            image={menuSizeXL}
                            priceExtra={calculateExtraPrice(priceXL)}
                            isSelected={menuSize === MENU_SIZE_XL}
                            onTileSelected={_idProduct =>
                                this.onProductSelected(MENU_SIZE_XL)
                            }
                            isFromCart={isFromCart}
                        />
                    )}
                    {existsInL && (
                        <SelectableSizeTile
                            id={id}
                            price={priceL}
                            selectableSizeName={menuSizeName[MENU_SIZE_L]}
                            image={menuSizeL}
                            priceExtra={calculateExtraPrice(priceL)}
                            isSelected={menuSize === MENU_SIZE_L}
                            onTileSelected={_idProduct =>
                                this.onProductSelected(MENU_SIZE_L)
                            }
                            isFromCart={isFromCart}
                        />
                    )}

                    <SelectableSizeTile
                        id={id}
                        image={menuSizeM}
                        selectableSizeName={menuSizeName[MENU_SIZE_M]}
                        priceExtra={calculateExtraPrice(price)}
                        price={price}
                        isSelected={menuSize === MENU_SIZE_M}
                        onTileSelected={_idProduct =>
                            this.onProductSelected(MENU_SIZE_M)
                        }
                        isFromCart={isFromCart}
                    />

                    {existsInS && (
                        <SelectableSizeTile
                            id={id}
                            price={priceS}
                            selectableSizeName={menuSizeName[MENU_SIZE_S]}
                            image={menuSizeS}
                            isSelected={menuSize === MENU_SIZE_S}
                            onTileSelected={_idProduct =>
                                this.onProductSelected(MENU_SIZE_S)
                            }
                            isFromCart={isFromCart}
                        />
                    )}
                </TilesContainer>
            </Container>
        )
    }
}

const Container = styled.div``
const TilesContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;
    margin-bottom: 20px;
`
const StyledH4 = styled(H4)`
    margin-vertical: 20px;
    align-self: center;
`
export { CatalogMenuSize }
